<!--
  扫码支付
-->
<template>
  <KeyboardPro
    width="520"
    type="2"
    @trigger="keyBoardInput"
    @keyBack="keyBack"
    @ok="doPay"
  >
    <template v-slot:input="{ confirm }">
      <a-input
        placeholder="直接扫码或手动输入付款码"
        v-model="paymentCode"
        allow-clear
        size="large"
        class="prefix-input mt-1x"
        ref="scanRef"
        @pressEnter="confirm"
        @focus="codeFocus"
      >
        <span slot="prefix" class="primary font-xxl">付款码</span>
        <a-icon type="scan" slot="suffix" class="primary font-xxl" />
      </a-input>
    </template>
    <a-input
      v-show="propParam.combinedPayment"
      slot="midSlot"
      placeholder="本地收款金额，不填写默认应付金额"
      allow-clear
      size="large"
      style="margin-top: 13px;"
      class="prefix-input"
      v-model="money"
      @focus="moneyFocus"
    >
      <span slot="prefix" class="primary">收款金额</span>
      <i
        style="color:#FFA735;"
        class="iconfont iconrenmingbiriyuan font-xxxl"
        slot="suffix"
      ></i>
    </a-input>
  </KeyboardPro>
</template>
<script>
import KeyboardPro from "./KeyboardPro.vue";
import {
  tradePaymentInfoMicropayV2,
  tradePaymentInfoStatus
} from "@/api/order";
import { myMixin } from "./mixin";

export default {
  name: "newScan",
  components: { KeyboardPro },
  mixins: [myMixin],
  props: {
    propParam: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      paymentCode: "", // 付款码
      money: "", // 收款金额
      isFocus: false,
      loading: false, // 是否支付中
      loopTimer: null // 轮询支付定时器
    };
  },
  computed: {},
  created() {
    try {
      window.test.optScan("1"); //（传参数为1那么回调的js方法是payScan，0是scanCode方法）
      window.payScan = this.payScan; // 获取付款码
      // window.test.readEwm();
    } catch (error) {
      console.log("created：扫码支付，硬件启用失败：", error);
    }
  },
  destroyed() {
    clearTimeout(this.loopTimer);
    try {
      window.test.optScan("0");
    } catch (error) {
      console.log("destroyed：扫码支付，硬件启用失败：", error);
    }
  },
  methods: {
    payScan(res) {
      this.paymentCode = res;
      this.doPay();
    },
    doPay() {
      if (!this.paymentCode) {
        this.$message.warning("请先输入付款码");
        return;
      }
      if (this.loading) {
        this.$message.warning("请勿重复扫码");
        return;
      }
      this.loading = true;
      const data = {
        orderNo: this.propParam.orderNumber,
        authCode: this.paymentCode,
        productName: ""
      };
      this.$store.commit("common/updateLoading", true);
      tradePaymentInfoMicropayV2(data, { loading: false })
        .then(res => {
          // 支付成功
          if (res == "PAID") {
            this.paySuccess();
            this.resetData();
            return;
          }
          // 等待支付
          if (res == "PAYING") {
            this.getStatusLoop();
            return;
          }
          // 支付失败
          if (res == "PAY_FAIL") {
            this.paySpeak("支付失败，请重新支付");
            this.$message.error("支付失败，请重新支付");
            this.resetData();
            return;
          }
          // // 支付超时or订单已经失效（30分钟未支付失效）
          // // 这种场景，已经走接口的catch了，不会在这边执行
          // if (res == "CANCEL") {
          //   console.log("订单已经失效，请重新下单+++++");
          //   return;
          // }
        })
        .catch(() => {
          this.resetData();
        });
    },
    // 轮询支付状态
    getStatusLoop() {
      if (this.loopTimer) {
        clearTimeout(this.loopTimer);
      }
      this.loopTimer = setTimeout(() => {
        tradePaymentInfoStatus(
          { orderNo: this.propParam.orderNumber },
          { loading: false }
        )
          .then(res => {
            if (res == "PAYING") {
              this.$message.info("等待支付中...");
              this.getStatusLoop();
              return;
            }
            if (res == "PAID") {
              this.paySuccess();
              this.resetData();
              return;
            }
            // 支付失败
            if (res == "PAY_FAIL") {
              this.paySpeak("支付失败，请重新支付");
              this.$message.error("支付失败，请重新支付");
              this.resetData();
              return;
            }
          })
          .catch(() => {
            this.resetData();
          });
      }, 1000);
    },
    // 键盘输入
    keyBoardInput(val) {
      // 输入的内容放到 付款码
      if (!this.isFocus) {
        let str = this.paymentCode;
        str += String(val);
        this.paymentCode = str;
      } else {
        // 输入的内容放到 收款金额
        let str = this.money;
        str += String(val);
        this.money = str;
      }
    },
    // 键盘退格
    keyBack() {
      if (!this.isFocus && this.paymentCode) {
        this.paymentCode = this.paymentCode.substr(
          0,
          this.paymentCode.length - 1
        );
      } else if (this.isFocus && this.money) {
        this.money = this.money.substr(0, this.money.length - 1);
      }
    },
    codeFocus() {
      this.isFocus = false;
    },
    moneyFocus() {
      this.isFocus = true;
    },
    resetData() {
      this.paymentCode = "";
      this.loading = false;
      this.$store.commit("common/updateLoading", false);
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.ant-input.ant-input-lg {
  font-size: 18px;
}
</style>
